import concat from 'lodash/concat';

import predefinedBlocksContainers
  from './predefined_blocks_containers.js';

import predefinedBlocksContent
  from './content/predefined_blocks_content.js';


const predefinedBlocks = Object.freeze(concat([],
  predefinedBlocksContainers,
  predefinedBlocksContent
));

export default predefinedBlocks;